import "./App.css";
import "../src/assets/css/style.css";
import ThemeProvider from "./theme/ThemeProvider";
import { useRoutes } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import router from "./router";
import { SnackBarAlertProvider } from "./contexts/SnackbarContext";
import { EntityProvider } from "./contexts/EntityContext";
import { LocalStorageProvider } from "./contexts/LocalStorageContext";
import { PropertyReportProvider } from "./contexts/PropertyReportContext";
function App() {
  const content = useRoutes(router());

  return (
    <ThemeProvider>
      <LocalStorageProvider>
        <SnackBarAlertProvider>
          <EntityProvider>
            <PropertyReportProvider>
              <CssBaseline />
              {content}
            </PropertyReportProvider>
          </EntityProvider>
        </SnackBarAlertProvider>
      </LocalStorageProvider>
    </ThemeProvider>
  );
}

export default App;
